import { render, staticRenderFns } from "./BatchesGrid.vue?vue&type=template&id=6d4d0dd8"
import script from "./BatchesGrid.vue?vue&type=script&lang=js"
export * from "./BatchesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports